module.exports = __webpack_public_path__ + "assets/img/introduction_03.55925b37.png";